const defaultParametersState = {
  transactionStatusesData: null,
  transactionTypesData: null,
  orderStatusesData: null,
  postLoginCardData: null,
};

export { defaultParametersState };
